import React, { useMemo, useState } from 'react';
import { Typography, Box } from "@material-ui/core";
import { Accordion, AccordionHeader, AccordionBody, Button, Card, List, ListItem, ListItemPrefix, Chip } from '@material-tailwind/react';
import { ArrowPathIcon, MagnifyingGlassIcon, ChevronDownIcon, FunnelIcon } from '@heroicons/react/24/outline';
import WarningIcon from '@mui/icons-material/PriorityHigh';
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { usuario_habilitado_sede } from '../funcionesGenerales';
import {useTramites} from '../hooks/useTramites';

// Reutilizamos tus utilidades de filtrado que ya funcionan perfecto
const filterUtils = {
  porRegion: (tramites, filtros) => {
    if (!filtros?.region?.length) return tramites;
    return tramites.filter(t => t && filtros?.region?.includes(t.region));
  },
  porEstado: (tramites, estado) => {
    return tramites.filter(t => t?.status?.[t.status.length - 1]?.texto === estado);
  },
  porTipo: (tramites, tipo) => {
    return tramites.filter(t => t?.tipo === tipo);
  }
};

export const TramitesPorUsuario = ({
  resumen,
  refetch,
  setAbrirOtros,
  filtros2,
  setFiltros2,
  solicitanteSeleccionado,
  setSolicitanteSeleccionado
}) => {
  const { usuario } = useContextoGlobal();
  const [open, setOpen] = useState(1); // Control de los acordeones
  const { tramitesFiltrados, hayFiltros, acciones,ESTADOS_CONFIG,TIPOS_TRAMITE } = useTramites();

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  const toggleFiltro = (campo, valor) => {
    //setFiltros2({...filtros2, [campo]: valor}) // esto cuando quiera filtrar por los 3 parametros
    setFiltros2({[campo]: valor})
  };

  const resetear = () => {
    setFiltros2({ ...filtros2, tipo: [], estado: [], region: [] });
    setSolicitanteSeleccionado(null);
  };

  return (
    <div className="flex flex-col gap-4">
      <hr className="my-2 border-blue-gray-50" />

      {/* ACORDEÓN DE FILTROS */}
      <Accordion open={open === 1} icon={<ChevronDownIcon className={`mx-auto h-4 w-4 transition-transform ${open === 1 ? "rotate-180" : ""}`} />}>
        <AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3 text-sm font-bold text-blue-gray-800">
          <ListItemPrefix><FunnelIcon className="h-5 w-5 mr-2" /></ListItemPrefix>
          Estados
        </AccordionHeader>
        <AccordionBody className="py-1">
          <List className="p-0">
            {ESTADOS_CONFIG.map(config => {
              if (config.adminOnly && !usuario.sede_admin) return null;

              let cant = 0;
              if(resumen?.porEstado?.length){
                cant = resumen?.porEstado?.find(estado => estado._id === config.value)?.total || 0;
              }
              return (
                <ListItem 
                  key={config.key} 
                  selected={filtros2?.estado?.includes(config.tipo)}                
                  className="py-2" 
                  onClick={() => toggleFiltro('estado', config.value)}>
                  <Typography color="blue-gray" className="mr-auto font-normal text-sm">{config.label}</Typography>
                  <Chip value={cant} size="sm" variant="ghost" color={cant > 0 ? "blue" : "blue-gray"} />
                </ListItem>
              );
            })}
          </List>
        </AccordionBody>
      </Accordion>
      <Accordion open={open === 3} icon={<ChevronDownIcon className={`mx-auto h-4 w-4 transition-transform ${open === 3 ? "rotate-180" : ""}`} />}>
        <AccordionHeader onClick={() => handleOpen(3)} className="border-b-0 p-3 text-sm font-bold text-blue-gray-800">
          <ListItemPrefix><FunnelIcon className="h-5 w-5 mr-2" /></ListItemPrefix>
          Tipos de Trámite
        </AccordionHeader>
        <AccordionBody className="py-1">
          <List className="p-0">
            {TIPOS_TRAMITE.map(config => {
              if (config.adminOnly && !usuario.sede_admin) return null;
              
              let cant = 0;
              if(resumen?.porTipo?.length){
                cant = resumen?.porTipo?.find(tipo => tipo._id === config.tipo)?.total || 0;
              }

              return (
                <ListItem 
                  key={config.tipo} 
                  selected={filtros2?.tipo?.includes(config.tipo)} 
                  onClick={() => toggleFiltro('tipo', config.tipo)} 
                  className="py-2">
                  <Typography className="mr-auto font-normal text-xs">{config.label}</Typography>
                  <Chip value={cant} size="sm" variant="ghost" />
                </ListItem>
              );
            })}
          </List>
        </AccordionBody>
      </Accordion>
    </div>
  );
};


